import { getHTMLElementFromRoot } from "../helper";
import { DrawerStatusTypes } from "../constants/app";

export function dispatchDrawerStatusEvent(status: DrawerStatusTypes): void {
  dispatchEvent("phn-level-0", "phnDrawerStatus", {
    bubbles: true,
    composed: true,
    detail: { status },
  });
}

export function dispatchEvent(
  from: string,
  eventName: string,
  {
    bubbles,
    detail,
    composed,
    cancelable,
  }: {
    bubbles?: boolean;
    cancelable?: boolean;
    composed?: boolean;
    detail?: unknown;
  },
): void {
  const event = new CustomEvent(eventName, {
    detail,
    bubbles,
    cancelable,
    composed,
  });
  const element = getHTMLElementFromRoot(from);

  element?.dispatchEvent(event);
}
